import { IconCheck } from "@tabler/icons-react";
import type { CFDIDeSolicitud } from "@/lib/types";
import { Card, Divider, Group, Stack, Text, ThemeIcon } from "@/components/ui";

/**
 * Vista solo-lectura de los N CFDIs vinculados al ZIP · cada item
 * resume slot, UUID corto, total y emisor.
 */
export function CfdisCargadosCard({ cfdis }: { cfdis: CFDIDeSolicitud[] }) {
  const ordenados = cfdis.slice().sort((a, b) => a.numeroSlot - b.numeroSlot);
  return (
    <Card padding="lg">
      <Stack gap="md">
        <Group gap="sm" align="flex-start">
          <ThemeIcon variant="filled" color="multiva" size="lg">
            <IconCheck size={20} stroke={1.8} />
          </ThemeIcon>
          <div className="flex-1">
            <Text fw={600}>CFDIs cargados</Text>
            <Text size="sm" c="dimmed">
              {cfdis.length} CFDI(s) vinculados a esta solicitud.
            </Text>
          </div>
        </Group>
        <Divider />
        <Stack gap="xs">
          {ordenados.map((c) => (
            <CfdiCargadoItem key={c.id} cfdi={c} />
          ))}
        </Stack>
      </Stack>
    </Card>
  );
}

function CfdiCargadoItem({ cfdi }: { cfdi: CFDIDeSolicitud }) {
  return (
    <div className="rounded-lg border border-border px-3 py-2.5">
      <Group justify="space-between" wrap="nowrap">
        <Group gap={8} align="baseline">
          <Text size="sm" fw={600}>
            CFDI {cfdi.numeroSlot}
          </Text>
          <code className="rounded bg-muted px-1.5 py-0.5 font-mono text-[11px]">{cfdi.uuid.slice(0, 13)}…</code>
        </Group>
        <Text size="sm" fw={500}>
          ${cfdi.total.toFixed(2)}
        </Text>
      </Group>
      <Text size="xs" c="dimmed" className="mt-0.5">
        {cfdi.nombreEmisor} · <code className="rounded bg-muted px-1 py-0.5 font-mono text-[10px]">{cfdi.rfcEmisor}</code>
      </Text>
    </div>
  );
}
